export default function initburgerMenu() {
  const openedMenuClass = 'menu-opened';
  const hoverClass = 'item-hovered';

  document.querySelectorAll('.btn-menu').forEach(btnMenu => {
    let body = document.querySelector('body');
    let menu = document.querySelector('#main-nav');
    let menuContainer = menu.querySelector('.menu-container');
    let delay;
    const menuItems = menu.querySelectorAll('[aria-haspopup="true"]');
    const focusableElements = menu.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])');
    const firstMenuItem = focusableElements[0];
    const lastMenuItem = focusableElements[focusableElements.length - 1];

    const openClose = (e) => {
      e.preventDefault();
      body.classList.toggle(openedMenuClass);
      const isMenuOpened = body.classList.contains(openedMenuClass);
      btnMenu.setAttribute('aria-expanded', isMenuOpened);

      if (isMenuOpened) {
        firstMenuItem.focus();
      } else {
        btnMenu.focus();
      }
    }

    btnMenu.addEventListener('click', openClose);
    
    menuItems.forEach((opener, i) => {
      if(opener.parentNode.querySelector('.drop')?.querySelectorAll('.active').length) opener.setAttribute('aria-expanded', 'true')

      opener.addEventListener('click', (e) => {
        e.preventDefault();
    
        const isOpen = opener.getAttribute('aria-expanded') === 'true';
        opener.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

        if (!isOpen) {
          menuItems.forEach((item, index) => {
            if (index !== i) item.setAttribute('aria-expanded', 'false');
          });
        }
        
        clearTimeout(delay);
        
        delay = setTimeout(()=>{
          menuContainer.scrollTo({
            top: opener.offsetTop - menuContainer.offsetTop,
            behavior: 'smooth'
          });
        }, 600)
      });
    });
    
    document.addEventListener('keydown', (e) => {
      if (document.body.classList.contains(openedMenuClass)) {
        const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        const isShiftPressed = e.shiftKey;
  
        if (isTabPressed) {
          if (isShiftPressed) {
            // Shift + Tab pressed
            if (document.activeElement === firstMenuItem) {
              e.preventDefault();
              lastMenuItem.focus();
            }
          } else {
            // Tab pressed
            if (document.activeElement === lastMenuItem) {
              e.preventDefault();
              firstMenuItem.focus();
            }
          }
        }
      }
    });

    document.addEventListener('click', (e) => {
      if (body.classList.contains(openedMenuClass) && !menu.contains(e.target) && !btnMenu.contains(e.target)) {
        openClose(e)
      }
    });

    // Add hover and focus event listeners to menu items
    menu.querySelectorAll('li').forEach(item => {
      item.addEventListener('mouseover', () => {
        item.classList.add(hoverClass);
      });
      item.addEventListener('mouseout', () => {
        item.classList.remove(hoverClass);
      });
      // Add focus and blur event listeners to focusable elements within li
      item.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])').forEach(focusable => {
        focusable.addEventListener('focus', () => {
          item.classList.add(hoverClass);
        });
        focusable.addEventListener('blur', () => {
          item.classList.remove(hoverClass);
        });
      });
    });
  });
}